<div class="user-signmature-assignments">
  @if (hasRfccsToSign) {
    <div class="rfcc-container sign-container">
      <h2>My assigned RFCCs</h2>
      <div class="header">
        <span class="doc-number"> Document Number</span>
        <span class="doc-number">Issued date</span>
        <span class="fraction"> Progress</span>
        <span class="fraction">&nbsp;</span>
        <span class="avaliable"> Next Signee</span>
      </div>
      @for (item of rfccList$ | async; track item) {
        <div class="item-row" (click)="navigateToRfccCertificate(item)" tabindex="0">
          <span class="doc-number"> {{ item.documentNumber }}</span>
          <span class="doc-number"> {{ item.issuedDate }} </span>
          <span class="fraction"> {{ signedFraction(item.signatureMatrix) }}</span>
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="icon ready">
              <mat-icon>assignment_add</mat-icon>
            </span>
          }
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Ready to signed</span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="icon blocked"><mat-icon>block</mat-icon> </span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Blocked by: {{ getNextToSignAsString(item.signatureMatrix) }}</span>
          }
        </div>
      }
    </div>
  }

  @if (hasRfocsToSign) {
    <div class="rfoc-container sign-container">
      <h2>My assigned RFOCs</h2>
      <div class="header">
        <span class="doc-number"> Document Number</span>
        <span class="doc-number">Issued date</span>
        <span class="fraction"> Progress</span>
        <span class="fraction">&nbsp;</span>
        <span class="avaliable"> Next Signee</span>
      </div>
      @for (item of rfocList$ | async; track item) {
        <div class="item-row" (click)="navigateToRfoCertificate(item)" tabindex="0">
          <span class="doc-number"> {{ item.documentNumber }}</span>
          <span class="doc-number"> {{ item.issuedDate }} </span>
          <span class="fraction"> {{ signedFraction(item.signatureMatrix) }}</span>
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="icon ready">
              <mat-icon>assignment_add</mat-icon>
            </span>
          }
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Ready to be signed</span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="icon blocked"><mat-icon>block</mat-icon> </span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Blocked by: {{ getNextToSignAsString(item.signatureMatrix) }}</span>
          }
        </div>
      }
    </div>
  }

  @if (hasMccsToSign) {
    <div class="rfoc-container sign-container">
      <h2>My assigned MCCs</h2>
      <div class="header">
        <span class="doc-number"> Document Number</span>
        <span class="doc-number">Issued date</span>
        <span class="fraction"> Progress</span>
        <span class="fraction">&nbsp;</span>
        <span class="avaliable"> Next Signee</span>
      </div>
      @for (item of mccList$ | async; track item) {
        <div class="item-row" (click)="navigateToMcCertificate(item)" tabindex="0">
          <span class="doc-number"> {{ item.documentNumber }}</span>
          <span class="doc-number"> {{ item.issuedDate }} </span>
          <span class="fraction"> {{ signedFraction(item.signatureMatrix) }}</span>
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="icon ready">
              <mat-icon>assignment_add</mat-icon>
            </span>
          }
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Ready to be signed</span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="icon blocked"><mat-icon>block</mat-icon> </span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Blocked by: {{ getNextToSignAsString(item.signatureMatrix) }}</span>
          }
        </div>
      }
    </div>
  }

  @if (hasCheckSheetsToSign) {
    <div class="csa-container sign-container">
      <h2>My assigned Checksheets</h2>
      <div class="header">
        <span class="fraction"> Progress</span>
        <span class="fraction">&nbsp;</span>
        <span class="avaliable"> Next Signee</span>
      </div>
      @for (item of checkSheetAssignmentList$ | async; track item) {
        <div class="item-row" (click)="navigateToCsa(item)" tabindex="0">
          <span class="doc-number"> {{ item.tagNumber }}</span>
          <span class="fraction"> {{ signedFraction(item.signatureMatrix) }}</span>
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="icon ready">
              <mat-icon>assignment_add</mat-icon>
            </span>
          }
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Ready to be signed</span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="icon blocked"><mat-icon>block</mat-icon> </span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Blocked by: {{ getNextToSignAsString(item.signatureMatrix) }}</span>
          }
        </div>
      }
    </div>
  }

  @if (hasHandoversToSign) {
    <div class="handover-container sign-container">
      <h2>My assigned RFOCs</h2>
      <div class="header">
        <span class="doc-number"> Document Number</span>
        <span class="doc-number">Issued date</span>
        <span class="fraction"> Progress</span>
        <span class="fraction">&nbsp;</span>
        <span class="avaliable"> Next Signee</span>
      </div>
      @for (item of handoverList$ | async; track item) {
        <div class="item-row" (click)="navigateToRfccCertificate(item)" tabindex="0">
          <span class="doc-number"> {{ item.documentNumber }}</span>
          <span class="doc-number"> {{ item.issuedDate }} </span>
          <span class="fraction"> {{ signedFraction(item.signatureMatrix) }}</span>
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="icon ready">
              <mat-icon>assignment_add</mat-icon>
            </span>
          }
          @if (isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Ready to signed</span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="icon blocked"><mat-icon>block</mat-icon> </span>
          }
          @if (!isMyTurn(item.signatureMatrix)) {
            <span class="avaliable">Blocked by: {{ getNextToSignAsString(item.signatureMatrix) }}</span>
          }
        </div>
      }
    </div>
  }
</div>
